import { render, staticRenderFns } from "./JordanelleTrail.vue?vue&type=template&id=94c60008&scoped=true&"
import script from "./JordanelleTrail.vue?vue&type=script&lang=js&"
export * from "./JordanelleTrail.vue?vue&type=script&lang=js&"
import style0 from "./JordanelleTrail.vue?vue&type=style&index=0&id=94c60008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c60008",
  null
  
)

export default component.exports